import React from 'react';
import { Box } from '@mui/material';
import Seo from './Seo';

const PrivacyPolicy = () => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Seo
        title="Privacy Policy"
        description="Privacy Policy for the New Mt. Zion Missionary Baptist Church website."
        path="/privacy-policy"
      />
      <div className="contactus-hero">Privacy Policy</div>
      <Box
        sx={{
          maxWidth: 900,
          padding: { xs: '1.5rem', md: '3rem' },
          lineHeight: 1.8,
          color: '#333',
        }}
      >
        <p style={{ color: '#777', marginBottom: '2rem' }}>
          Last Updated: February 26, 2026
        </p>

        <h2>1. Introduction</h2>
        <p>
          New Mt Zion Missionary Baptist Church (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;), located
          at 1321 N. Webster Avenue, Lakeland, FL 33805, is committed to
          protecting the privacy of our visitors, members, and online community.
          This Privacy Policy describes how we collect, use, and safeguard your
          personal information when you visit our website at nmzlakeland.org.
        </p>

        <h2>2. Information We Collect</h2>
        <p>We may collect the following types of information:</p>

        <h3>Personal Information You Provide</h3>
        <ul>
          <li>
            <strong>Contact Forms:</strong> Name, email address, phone number,
            and message content when you submit a contact request
          </li>
          <li>
            <strong>Event Registration:</strong> Name and contact details when
            you register for church events
          </li>
          <li>
            <strong>Volunteer Applications:</strong> Personal information
            submitted through volunteer and background check forms
          </li>
          <li>
            <strong>Member Information:</strong> Information provided through our
            members portal
          </li>
          <li>
            <strong>Donations:</strong> Payment information when making online
            donations (processed by third-party payment providers)
          </li>
        </ul>

        <h3>Information Collected Automatically</h3>
        <ul>
          <li>
            <strong>Analytics Data:</strong> We use Google Analytics (via
            Firebase) to collect anonymized usage data such as pages visited,
            time spent on site, browser type, and general location
          </li>
          <li>
            <strong>Device Information:</strong> Browser type, operating system,
            and device type used to access the website
          </li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Respond to your inquiries and contact requests</li>
          <li>Process event registrations and volunteer applications</li>
          <li>Send church-related communications and updates</li>
          <li>Process and acknowledge donations</li>
          <li>Improve our website and the services we offer</li>
          <li>Maintain the safety and security of our church community</li>
        </ul>

        <h2>4. Information Sharing</h2>
        <p>
          We do not sell, trade, or rent your personal information to third
          parties. We may share your information only in the following
          circumstances:
        </p>
        <ul>
          <li>
            <strong>Service Providers:</strong> With trusted third-party services
            that help us operate our website (such as Firebase for hosting and
            data storage, and payment processors for donations)
          </li>
          <li>
            <strong>Church Ministry:</strong> With church staff and ministry
            leaders as needed to fulfill your requests or facilitate your
            participation in church activities
          </li>
          <li>
            <strong>Legal Requirements:</strong> When required by law or to
            protect the rights and safety of our church and its members
          </li>
        </ul>

        <h2>5. Data Security</h2>
        <p>
          We take reasonable measures to protect your personal information from
          unauthorized access, alteration, disclosure, or destruction. Our
          website uses secure connections (HTTPS), and data is stored using
          Firebase, which provides industry-standard security measures. However,
          no method of electronic transmission or storage is 100% secure, and we
          cannot guarantee absolute security.
        </p>

        <h2>6. Third-Party Services</h2>
        <p>Our website uses or links to the following third-party services:</p>
        <ul>
          <li>
            <strong>Firebase / Google Cloud:</strong> Website hosting, database,
            and analytics
          </li>
          <li>
            <strong>YouTube:</strong> Embedded sermon and worship videos
          </li>
          <li>
            <strong>Facebook:</strong> Social media presence and links
          </li>
        </ul>
        <p>
          Each of these services has its own privacy policy governing how they
          handle your data. We encourage you to review those policies.
        </p>

        <h2>7. Children&#39;s Privacy</h2>
        <p>
          Our website is not directed at children under the age of 13. We do not
          knowingly collect personal information from children under 13 without
          parental consent. If you believe we have inadvertently collected
          information from a child under 13, please contact us so we can
          promptly remove it.
        </p>

        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Request access to the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your personal information</li>
          <li>Opt out of any communications from the church</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us using the
          information below.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with a revised &quot;Last Updated&quot; date. We
          encourage you to review this policy periodically.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please
          contact us:
        </p>
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          <li>
            <strong>New Mt Zion Missionary Baptist Church</strong>
          </li>
          <li>1321 N. Webster Avenue, Lakeland, FL 33805</li>
          <li>Phone: (863) 686-6793</li>
          <li>Email: info@nmzlakeland.org</li>
        </ul>
      </Box>
    </div>
  );
};

export default PrivacyPolicy;
